/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ExternalProjectLinksControllerFindAllQueryResponse, ExternalProjectLinksControllerFindAllQueryParams, ExternalProjectLinksControllerFindAll401, ExternalProjectLinksControllerFindAll403 } from "../../models/externalProjectLinksController/ExternalProjectLinksControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { externalProjectLinksControllerFindAll } from "../../clients/external-project-linksService/externalProjectLinksControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const externalProjectLinksControllerFindAllQueryKey = (params: ExternalProjectLinksControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/external-project-links'
}, ...(params ? [params] : [])] as const;
export type ExternalProjectLinksControllerFindAllQueryKey = ReturnType<typeof externalProjectLinksControllerFindAllQueryKey>;
export function externalProjectLinksControllerFindAllQueryOptions(params?: ExternalProjectLinksControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = externalProjectLinksControllerFindAllQueryKey(params);
  return queryOptions<ExternalProjectLinksControllerFindAllQueryResponse, ResponseErrorConfig<ExternalProjectLinksControllerFindAll401 | ExternalProjectLinksControllerFindAll403>, ExternalProjectLinksControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return externalProjectLinksControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List / resolve external project links
 * {@link /api/v1/external-project-links}
 */
export function useExternalProjectLinksControllerFindAll<TData = ExternalProjectLinksControllerFindAllQueryResponse, TQueryData = ExternalProjectLinksControllerFindAllQueryResponse, TQueryKey extends QueryKey = ExternalProjectLinksControllerFindAllQueryKey>(params?: ExternalProjectLinksControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ExternalProjectLinksControllerFindAllQueryResponse, ResponseErrorConfig<ExternalProjectLinksControllerFindAll401 | ExternalProjectLinksControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? externalProjectLinksControllerFindAllQueryKey(params);
  const query = useQuery({
    ...externalProjectLinksControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ExternalProjectLinksControllerFindAll401 | ExternalProjectLinksControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}